import { DocumentCalculationMethodEnum } from '@zaoblako/shared/modules/document/enums/document.calculation.method.enum';
import { DocumentCalculationMethodEnumI18n } from '@zaoblako/shared/modules/document/i18n/document.calculation.method.enum.i18n';
import { DocumentTypeKindEnum } from '@zaoblako/shared/modules/document/enums/document-type-kind.enum';
import { DocumentTypeKindEnumI18n } from '@zaoblako/shared/modules/document/i18n/document-type-kind-enum.i18n';
import { SerdeDtoClass } from '@zaoblako/shared/modules/serde/classes/serde-dto.class';
import { DocumentDtoKeysEnum } from '@zaoblako/shared/modules/document/enums/document-dto-keys.enum';
import { DtoMessageEnum } from '@zaoblako/shared/common/enums/dto.message.enum';
import { DocumentTypeCodeValidateTools } from '@zaoblako/shared/modules/document/classes/document.type.code.validate.tools';
import { commonEnumValidator } from '@zaoblako/shared/modules/serde/validators/common-enum.validator';
import type { DocumentTypeFindInterface } from '@zaoblako/shared/modules/document/dtos/document-type/document-type-find.dto';

import * as yup from 'yup';

/** Document type create and update APIs request body - DTO signature */
export interface DocumentTypeFormInterface {
  /** Type display name, required */
  name: string;
  /** Type description, optional */
  description?: string;
  /** Document type calculation method. Need for some reports. */
  method: DocumentCalculationMethodEnum;
  /** Document type kind. Need for some reports. */
  kind?: DocumentTypeKindEnum;
  /** Type of documents that can be created based on documents of this type */
  canSpawn?: DocumentTypeFindInterface;
}

/** Document type create and update APIs request body - DTO schema */
export const DocumentTypeFormDto = SerdeDtoClass.create<DocumentTypeFormInterface>(DocumentDtoKeysEnum.DOCUMENT_TYPE_FORM_DTO, {
  name: {
    label: 'Название',
    serializer: yup
      .string()
      .min(1, DtoMessageEnum.EMPTY_STRING),
  },
  description: {
    optional: true,
    label: 'Описание',
    serializer: yup.string(),
  },
  method: {
    label: 'Метод вычисления',
    serializer: commonEnumValidator(DocumentCalculationMethodEnum, DocumentCalculationMethodEnumI18n),
  },
  kind: {
    optional: true,
    label: 'Вид документа',
    serializer: commonEnumValidator(DocumentTypeKindEnum, DocumentTypeKindEnumI18n),
  },
  canSpawn: {
    optional: true,
    label: 'Тип, создаваемый на основании этого',
    serializer: (): yup.Schema<any> => yup.object({
      code: DocumentTypeCodeValidateTools
        .getInstance()
        .yupSchema,
    }),
  },
})
